module.exports = __webpack_public_path__ + "static/media/aq.65448909.svg";